import React from "react";
import { Tooltip, IconButton, Box } from "@mui/material";
import { Info } from "@mui/icons-material";

function CustomTooltip({ children, content, placement, styles, handeClick }) {
  const style = {
    backgroundColor: "white",
    margin: "0 auto",
    color: "black",
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    padding: "15px",
    ...styles,
  };

  return (
    <Tooltip
      title={<Box sx={{ pl: 2 }}>{content}</Box>}
      placement={placement ? placement : "right-end"}
      componentsProps={{ tooltip: { sx: style } }}
      disableFocusListener
    >
      {children ? (
        <Box>{children}</Box>
      ) : (
        <IconButton
          sx={{ ml: 1, color: "#6941C6" }}
          onClick={() => handeClick?.()}
        >
          <Info />
        </IconButton>
      )}
    </Tooltip>
  );
}

export default CustomTooltip;
